import { mdiChevronRight } from '@mdi/js'
import Icon from '@mdi/react'
import * as React from 'react'
import styles from './PresetCard.pcss'

interface PresetCardProps {
  title: React.ReactNode
  subtitle: React.ReactNode
  icon: React.ReactNode
  iconColor?: string
  isActive?: boolean
  onClick: () => void
  'data-testid'?: string
  className?: string
}

export function PresetCard(props: PresetCardProps) {
  const { title, subtitle, icon, iconColor, isActive, className, onClick } = props
  const testId = props['data-testid']
  const style = iconColor ? ({ '--preset-icon-color': iconColor } as React.CSSProperties) : undefined

  return (
    <div
      className={`${styles.preset} ${isActive ? styles.active : ''} ${className || ''}`}
      onClick={onClick}
      style={style}
      data-testid={testId}
    >
      <div className={styles.icon}>{icon}</div>
      <div className={styles.text}>
        <h5 className={styles.title}>{title}</h5>
        <p className={styles.description}>{subtitle}</p>
      </div>
      <div className={styles['icon-nav']}>
        <Icon path={mdiChevronRight} size="28px" />
      </div>
    </div>
  )
}
